<app-header [withBanner]="true" *ngIf="!hideHeaderAndFooter"></app-header>
<router-outlet (activate)="onActivate()"></router-outlet>
<app-footer *ngIf="!hideHeaderAndFooter"></app-footer>
